import React,{useEffect} from 'react'
import './Brand.css'
// import {data} from './DataBrand'
import useAuth from "../../hooks/useAuth"

function AllBrand() {

  const {state:{products,cart}, dispatch,count,setCount}=useAuth()
  // console.log(cart)
  console.log(count)
 useEffect(()=>{
  console.log(count)
 },[])
  return (
    <>
    <div className='mt-5 mx-5 Prroducts'>
    <div className='d-flex align-items-center justify-content-between'>
        <h1 className='fw-bold fs-1'>Products</h1>
        <h5 className="text-muted">View all</h5>
    </div>
   <div className='d-flex justify-content-center mt-2 '>
   <div class="d-flex " role="group" aria-label="Basic mixed styles example">
  <div className='item'><h5>ALL</h5></div>
  <div className='item'><h5>HEAD PHONE</h5></div>
  <div className='item'><h5>WATCH</h5></div>
  <div className=' item'><h5>PHONE</h5></div>

</div>
   </div>
  <div className='row'>
    {products.map((item)=>{
      return (
        <>
         <div className={` border-0 container container1 col-lg-3 col-md-4 col-sm-6 col-10 mt-2 p-2 `}  >
   
   <div className="containers rounded box d-flex flex-column container2 align-items-center shadow-sm ">
   <span className='bg-danger text-light px-2  me-auto ms-1 mt-2 rounded-pill'>10% off</span>
         <div className="card-body text-center">
         
         <img src={item.img} alt="" />
           <h2 className="product-name">
             <a href="#" alt='No image found' className='text-muted'>{item.name}</a>
           </h2>
           <div className="rating">
             <i className="bi bi-star-fill text-warning"></i>
             <i className="bi bi-star-fill text-warning"></i>
             <i className="bi bi-star-fill text-warning"></i>
             <i className="bi bi-star-fill text-warning"></i>
             <i className="bi bi-star-fill text-warning"></i>
           </div>
           <h2 className="price text-danger">{item.price}$</h2>
           <div className="btns d-flex justify-content-between">
            {/* {cart.some(p=>p.id===item.id)?(
              <a href="#" onClick={()=>{
                dispatch({
                  type:"ADD_TO_CART",
                  payload:item,
  
                })
               }}  alt='No image found'  className="add-to-cart-btn">
               <i className="bi bi-cart4 me-1"></i>
               Add to Cart
             </a>
            ):( <a href="#" onClick={()=>{
              dispatch({
                type:"ADD_TO_CART",
                payload:item,

              })
             }}  alt='No image found' className="add-to-cart-btn" >
             <i className="bi bi-cart4 me-1"></i>
             Add to Cart
           </a>)
            } */}
            {count.includes(item) ? (
             <a href="#cart" onClick={() => setCount(count.filter((e)=> e.id !== item.id))} className="rem-to-cart-btn">
               <i className="bi bi-cart4 me-1"></i>
              REM TO CART</a>
                
            ) : (
              <a href="#cart" onClick={()=>{setCount([item,...count])}}  alt='No image found'  className="add-to-cart-btn">
               <i className="bi bi-cart4 me-1"></i>
               Add to Cart
             </a>
               
            ) }
            
            
            <a href="#" alt='No image found' className="add-to favorite mt-1 fs-4 ms-3">
                <i className="bi bi-heart"></i>
                </a>
           </div>
         </div>
       </div>
       </div>
        </>
      )
    })}
  </div>
    </div>
    </>
  )
}

export default AllBrand